<template>
  <el-form ref="postForm" :model="postForm">
    <el-form-item>
      <el-input v-model="postForm.children" rows="10" type="textarea" placeholder="请输入ID(逗号分隔)" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="fnHandleSave()">导入学生</el-button>
    </el-form-item>
  </el-form>
</template>
<script>

const defaultForm = {
  activity_id: '',
  children: ''
}

export default {
  name: 'ImproveStudent',
  props: {
    activityId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      postForm: Object.assign({}, defaultForm)
    }
  },
  created() {
    if (this.activityId) {
      this.postForm.activity_id = this.activityId
    }
  },
  methods: {
    fnHandleSave: function() {
      if (!this.postForm.children) {
        this.$message.error('请输入逗号分隔的ID')
        return
      }
      this.$http.importJoinList(this.postForm).then(res => {
        if (res.code == 200) {
          this.$alert(res.desc, '导入结果', {
            confirmButtonText: '确定',
            callback: action => {}
          })
          this.postForm.children = ''
          this.$emit('successCBK')
        }
      })
    }
  }
}
</script>
  <style lang="scss" scope>

  .combo-group {
    .tuolele-main-search {
      .el-button {
        margin-left:0px!important
      }
      .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
        padding-left: 20px !important;
      }
      .el-tabs--top .el-tabs__item.is-top:last-child {
        padding-right: 20px !important;
      }
      .el-form-item__label {
        font-size: 16px;
        color: #333;
      }
      .el-form-item__content {
        margin: 0 20px 0 12px;
      }
    }
  }
  </style>
